import * as GetDocumentPreviewTypes from 'src/actions/project/get-document-preview/Types';
import {
  PreviewDocumentAction,
  PreviewDocumentSuccess,
  SetPreviewDocumentNumberOfPages
} from 'src/actions/project/get-document-preview/GetDocumentPreview.actions';

export interface GetDocumentPreviewState {
  documentPreview?: File;
  numPages?: number;
  loading: boolean;
  error: boolean;
}

const initialState: GetDocumentPreviewState = {
  loading: false,
  error: false,
};

export function GetDocumentPreviewReducer(
  state: GetDocumentPreviewState = initialState,
  action: PreviewDocumentAction
): GetDocumentPreviewState {

  switch (action.type) {
    case GetDocumentPreviewTypes.PREVIEW_FILE_ATTEMPT:
      return {...state, documentPreview: undefined, loading: true, error: false};
    case GetDocumentPreviewTypes.PREVIEW_FILE_SUCCESS:
      const documentPreview: File = (action as PreviewDocumentSuccess).payload;
      return {...state, documentPreview: documentPreview, loading: false, error: false};
    case GetDocumentPreviewTypes.SET_PREVIEW_FILE_NUMBER_OF_PAGES:
      const numPages: number = (action as SetPreviewDocumentNumberOfPages).payload;
      return {...state, numPages: numPages, loading: false, error: false};
    case GetDocumentPreviewTypes.PREVIEW_FILE_FAILURE:
      return {...state, documentPreview: undefined, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/GetDocumentPreviewReducer.tsx